import * as Yup from "yup";

export const DEFAULT_TIMEOUT_SECONDS = 10;

export const webhookValidationSchemaFields = {
  name: Yup.string().trim().required("Name is required"),
  callbackUrl: Yup.string()
    .required("Callback URL is required")
    .test("https-url", "Callback URL must be a valid https:// URL", value => {
      if (!value) {
        return false;
      }
      try {
        const url = new URL(value);
        return url.protocol === "https:";
      } catch {
        return false;
      }
    }),
  timeoutSeconds: Yup.number()
    .typeError("Timeout must be a number")
    .integer("Timeout must be an integer")
    .min(1, "Timeout must be at least 1 second")
    .max(25, "Timeout must be at most 25 seconds")
    .nullable(),
  payloadTemplate: Yup.string().trim().required("Payload template is required"),
  notes: Yup.string()
};

export const hasUniqueHeaderKeys = (headers: Record<string, string> | undefined): boolean => {
  if (!headers) {
    return true;
  }
  // Object keys are inherently unique; the HeadersField collapses duplicates,
  // but we re-check defensively in case the form value is built elsewhere.
  return Object.keys(headers).length === Object.keys(headers).filter(k => k.trim().length > 0).length;
};
